// app/giustificativi/giustificativo.js

(function () {
    'use strict';
    var controllerId = 'autorizzazione';
    angular.module('app').controller(controllerId, ['$rootScope', '$routeParams', '$filter', 'common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', autorizzazioneFn]);

    function autorizzazioneFn($rootScope, $routeParams, $filter, common, bDialog, $uibModal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Autorizzazioni';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);                
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.super = $rootScope.isAuthorized('SUPER');        
                
        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ruoli = [];
        vm.list.user = [];
        vm.list.ordine = ['utente','ruolo'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        //Elenchi dettaglio      
        
        //Filtro
        vm.filter = {};

        vm.fUserId = 0;
        vm.fRoleId = 0;
        vm.fAreaId = -1;
        vm.filter.userId = vm.fUserId;
        vm.filter.roleId = vm.fRoleId;
        vm.filter.areaId = vm.fAreaId;
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;                   

        //Gestione giustificativo        
        vm.add = addAutorizzazione;
        vm.edit = editAutorizzazione;
        vm.delete = deleteAutorizzazione;
        

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getUsers(), getRuoli()];
            common.activateController(promises, controllerId)
                .then(function () {

                });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;

            vm.filter.userId = vm.fUserId == null ? 0 : vm.fUserId;
            vm.filter.roleId = vm.fRoleId == null ? 0 : vm.fRoleId;
            vm.filter.areaId = vm.fAreaId == null ? -1 : vm.fAreaId;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.authorization_countByFilter(vm.filter.userId, vm.filter.roleId).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.authorization_getAllByFilter(vm.pageSize, vm.page, vm.filter.userId, vm.filter.roleId, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        item.showCosti = (item && ((item.iTags & 2) == 2));
                        item.showProfiliOrari = (item && ((item.iTags & 4) == 4));
                        item.showTeam = (item && ((item.iTags & 8) == 8));
                        vm.records.push(item);
                    });
                    //vm.records.push.apply(vm.records, data);                   
                }
                console.info('autorizzazioni', vm.records);
                vm.loading = false;               
            });            
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getUsers() {
            return datacontext.user_getAllList().then(function (data) {
                return vm.list.user = data;
            });
        }

        function getRuoli() {
            return datacontext.role_getAllList().then(function (data) {
                return vm.list.ruoli = data;
            });
        }

        function addAutorizzazione() {
            var modalAutorizzazione = {};
            modalAutorizzazione.Id = 0;   // devo aggiungere un nuovo record e sappiamo che ogni nuovo record è identificato da un Id pari a 0
            
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/autorizzazione/modal/autorizzazioneAddEdit.html?version=30',   // utilizzo la stessa modale sia per aggiungere che per modificare                                                                           
                controller: 'autorizzazioneAddEdit',
                resolve: {                                          // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                    autorizzazione: function () {                            // in questo caso passiamo un solo oggetto che si chiama 'giustificativo' che ha come valore modalIncontro
                        return modalAutorizzazione;
                    },
                    users: function () {
                        return vm.list.user;
                    },
                    roles: function () {
                        return vm.list.ruoli;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {               // eseguito a seguito della chiusura della modale
                if (!returnItem) return logError('Errore durante l\'inserimento del dato ');   // analizza l'oggetto tornato 'returnItem' = 'giustificativoAddEdit.result'
                //  (può essere nullo se l'aggiornamento non va a buon fine)
                logSuccess('Autorizzazione aggiunta con successo');
                cerca();     //Aggiorno i dati in visualizzazione
            });
        }

        function editAutorizzazione(item, index) {
            var modalAutorizzazione = {};
            angular.copy(item, modalAutorizzazione);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/autorizzazione/modal/autorizzazioneAddEdit.html?version=30',   // utilizzo la stessa modale sia per aggiungere che per modificare                                                                           
                controller: 'autorizzazioneAddEdit',
                resolve: {                                          // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                    autorizzazione: function () {                            // in questo caso passiamo un solo oggetto che si chiama 'giustificativo' che ha come valore modalIncontro
                        return modalAutorizzazione;
                    },
                    users: function () {
                        return vm.list.user;
                    },
                    roles: function () {
                        return vm.list.ruoli;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {               // eseguito a seguito della chiusura della modale
                if (!returnItem) return logError('Errore durante la modifica del dato ');   // analizza l'oggetto tornato 'returnItem' = 'giustificativoAddEdit.result'
                logSuccess('Dati salvati con successo');
                cerca();      //Aggiorno i dati in visualizzazione
            });
        }

        function deleteAutorizzazione(item) {
            var msg = "l'autorizzazione " + item.Id;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.authorization_delete(item.Id).then(function (data) {
                    if (!data) return logError('Errore durante la rimozione del dato');
                    logSuccess('Autorizzazione eliminata con successo');
                    var index = vm.records.indexOf(item)
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }
    }
})();
